import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { selectDefaultRequiresUserVerification } from "../../../state/reducers/projectWizard/projectWizardSelectors.js";
import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class OTPPanelSummary extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    // resourceType: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    configCopyKey: PropTypes.string,
    configOptions: PropTypes.object,
    copyKey: PropTypes.string.isRequired,

    defaultRequiresUserVerification: PropTypes.bool,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard.otp_panel"
  };

  // -- RENDER -- //

  renderActive() {
    const {
      formikProps: { values },
      defaultRequiresUserVerification,
      copyKey,
      copy
    } = this.props;

    return (
      <p>
        <strong>{copy(`${copyKey}.title`)}: </strong>
        {defaultRequiresUserVerification === undefined
          ? copy(`${copyKey}.not_applicable`)
          : values.requiresUserVerification
          ? copy(`${copyKey}.enabled`)
          : copy(`${copyKey}.disabled`)}
      </p>
    );
  }

  renderInactive() {
    return null;
  }

  render() {
    return this.renderActive();

    // switch (view) {
    //   case PANEL_STATES.ACTIVE:
    //     return this.renderActive();
    //   case PANEL_STATES.OPTIONAL:
    //     return this.renderOptional();
    //   default:
    //     return this.renderInactive();
    // }
  }
}

const mapStateToProps = state => ({
  defaultRequiresUserVerification: selectDefaultRequiresUserVerification(state),
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(OTPPanelSummary);
